import { render } from "./index.vue?vue&type=template&id=c9f8ca68"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=c9f8ca68&lang=less"

import exportComponent from "/Users/aleksandrzulaev/Sites/Landings/ipervushin.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__